import { get } from 'lodash';

const SERVER_USER_ID_FIELDS = ['id', 'userUuid', 'uuid', 'userId'];

export const getServerUserId = (user) => {
  const userId = SERVER_USER_ID_FIELDS.map((field) => get(user, field)).find(
    (id) => typeof id === 'string' && id.trim()
  );

  return userId ? userId.trim() : undefined;
};

export const isUserMatchingId = (user, expectedUserId) => {
  const userId = getServerUserId(user);

  return typeof expectedUserId === 'string' && !!expectedUserId.trim() && userId === expectedUserId.trim();
};
